/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');


// $ = require('jquery');

let select2 = require('select2/dist/js/select2.full.js');
require('air-datepicker');


$(document).ready(function () {
  // require('air-datepicker/dist/js/i18n/datepicker.en');
  // require('air-datepicker/dist/js/i18n/datepicker.fr');

  $('.js-select2').select2({
    minimumResultsForSearch: Infinity,
  });

  let newbieData = $('#newbie');
  //initialize air-datepicker
  let dp = $('.js-form-datepicker').datepicker({
    dateFormat: "dd M yyyy",
    onSelect: function onSelect(fd, date, inst) {
      let plan = inst.$el.next();
      let month = '' + (date.getMonth() + 1);
      let day = '' + date.getDate();
      let year = date.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      plan.val([year, month, day].join('-'));
    }
  }).data('datepicker');

  if(dp !== undefined) {
    dp.update('minDate', new Date(newbieData.data('mindate')));
    dp.update('maxDate', new Date(newbieData.data('maxdate')));
  }

  let jsShowManagers = $('.js-show-managers');
  jsShowManagers.off('click').on('click', () => {
    jsShowManagers.find('img').css('transform', 'rotate(180deg)');
    jsShowManagers.toggleClass('d-block');
    jsShowManagers.hide();
    $('.js-rnd-staff').toggleClass('d-none');
  });


  // options by task
  $('.js-show-action').on('click', function () {
    $(this).parent().find('.js-action').show();
  });
  $(document).mouseup(function (e) {
    let popup = $(".js-action");
    if (!$('.js-show-action').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
      popup.hide(100);
    }
  });


  // options by tasks result
  $('.js-show-action-probation').on('click', function () {
    $('.js-action-probation').show();
  });
  $(document).mouseup(function (e) {
    let popup = $(".js-action-probation");
    if (!$('.js-show-action-probation').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
      popup.hide(100);
    }
  });


  // options by probation period review
  $('.js-show-action-task').on('click', function () {
    $(this).parent().parent().find('.js-action-task').show();
    // $('.js-action-task').show();
  });
  $(document).mouseup(function (e) {
    let popup = $(".js-action-task");
    if (!$('.js-show-action-task').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
      popup.hide(100);
    }
  });

  let formatDateToS = function(date) {
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    let year = date.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };

  $('.js-show-modal').on('click', function (e) {
    e.preventDefault();
    let minDate = $(this).data('mindate');
    let maxDate = $(this).data('maxdate');
    let currentDate = $(this).data('currentdate');
    let modal =$('#' + $(this).data('modal'));
    let dp = modal.find('input.js-form-period-datepicker').datepicker({
      minDate: new Date(),
      dateFormat: "dd M yyyy"
    }).data('datepicker');

    if(dp !== undefined) {
      dp.update('minDate', new Date(minDate));
      dp.update('maxDate', new Date(maxDate));
      if(currentDate) {
        dp.selectDate(new Date(currentDate));
      }
    }

    modal.modal('show');
  });

  let storedCompanies = [];

  let loadCompanies = function(storedCompanies) {
    if(storedCompanies.length) {
      return storedCompanies;
    }

    $.ajax({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      type: "GET",
      url: '/company',
      async: false,
      data: null,
      success: function (response) {
        console.log(response);
        storedCompanies = storedCompanies.concat(response.data);
      },
      error: function (response) {

      }
    });
    return  storedCompanies;
  };

  let isCompanyLoaded = false;
  $('.js-show-modal-report').on('click', function (e) {
    e.preventDefault();
    let modal =$('#' + $(this).data('modal'));
    storedCompanies = storedCompanies.length ? storedCompanies : loadCompanies(storedCompanies);
    let companies = storedCompanies;
    let select = modal.find('#company');

    console.log(select.find('option').length);

    if(companies.length && isCompanyLoaded === false) {
      $.each(companies, function(key, value) {
        select
            .append($('<option>', { value : value.id })
                .text(value.name));
      });
      isCompanyLoaded = true;
    }
    modal.modal('show');
  });

  $('.js-show-modal-import').on('click', function (e) {
    e.preventDefault();
    let modal =$('#' + $(this).data('modal'));
    modal.modal('show');
  });

  $('.js-company-choice').on('change', function () {
    let id = $(this).val();
    let form = $('#report-form');
    let department = form.find('#department');
    department.html('');
    if(!id) {
      return false;
    }

    let company = storedCompanies.find(el => el.id === parseInt(id));

    if(company === undefined) {
      return false;
    }

    if(company.departments.length) {
      $.each(company.departments, function(key, value) {
        department
            .append($('<option>', { value : value.id })
                .text(value.name));
      });
    }

  });

  $('.js-report-form-datepicker').datepicker({
    dateFormat: "dd M yyyy"
  });

  $('.js-download-report-link').on('click', function (e) {
    $('.adp-modal-field-invalid-text').remove();
    e.preventDefault();
    let form = $('#report-form');
    let inputs = form.find('.adp-input');
    let route = $(this).attr('href');
    let isValid = true;
    $.each(inputs, function (key, input) {
      const field = $(input);
      if(field.val()) {
        let value = field.val();
        if(field.hasClass('cast-datetime')) {
          value = formatDateToS(field.datepicker({}).data('datepicker').lastSelectedDate);
          if(value === undefined) {
            isValid = false;
          }
        }

        route += '/' + value;
      } else {
        const error = '<span class="adp-modal-field-invalid-text" role="alert">'+ 'Обязательно для заполнения' +'</span>';
        field.after(error);
        isValid = false;
      }
    });

    if(isValid === false) {
      return false;
    } else {
      window.location = route;
    }
  });

  $('.js-change-period-form').submit(function (e) {
    e.preventDefault();
    let form = $(this);
    let route = form.attr('action');
    let dp = form.find('input.js-form-period-datepicker').datepicker().data('datepicker');
    let formattedDate = formatDateToS(dp.lastSelectedDate);
    $.ajax({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      type: "POST",
      url: route,
      data: {"period_at": formattedDate, },
      success: function () {
        location.reload();
      },
      error: function (response) {
        const json = $.parseJSON(response.responseText);
        $.each(json.errors, function(key, value){
          const field = form.find('#' + key);
          const label = form.find("label[for='" + key + "']");
          const error = '<span class="adp-modal-field-invalid-text" role="alert">'+ value[0] +'</span>';
          field.after(error);
          label.addClass('adp-modal-field-label-invalid');
        });
      }
    });
  });

  $('.js-close-actions').on('click', function() {
    $(this).parent().parent().hide();
  });


  let modalPrint = $('#printNotificationModal');
  if(modalPrint.hasClass('active')) {
    modalPrint.modal('show');
  }

  //Create task submit handler
  $('#create-task-form,#edit-task-form,#create-employee-form,#edit-employee-form').submit(function (e) {
      //clean last errors
      $('.adp-modal-field-invalid-text').remove();
      $('.adp-modal-field-label-invalid').removeClass('adp-modal-field-label-invalid');
      //process
      e.preventDefault();
      let form = $(this);
      $.ajax({
        type: "POST",
        url: $(this).attr( 'action' ),
        data: $(this).serialize(),
        success: function(){
          location.reload();
        },
        error: function (request) {
          const json = $.parseJSON(request.responseText);
          $.each(json.errors, function(key, value){
            const field = form.find('#' + key);
            const label = form.find("label[for='" + key + "']");
            const error = '<span class="adp-modal-field-invalid-text" role="alert">'+ value[0] +'</span>';
            field.after(error);
            label.addClass('adp-modal-field-label-invalid');
          });
        }
      });
   });

  //Button "edit task" handler
  $('.edit-task-form').click(function(e) {
    e.preventDefault();
    let form = $('#edit-task-form');
    form.attr('action', $(this).data('urlupdate'));
    //console.log($(this).data('url'));
    //clean last errors
    form.find('.adp-modal-field-invalid-text').remove();
    form.find('.adp-modal-field-label-invalid').removeClass('adp-modal-field-label-invalid');
    $.ajax({
      type: "GET",
      url: $(this).data('urledit'),
      success: function (response) {
        let dp = form.find('.js-form-datepicker').datepicker().data('datepicker');
        dp.update('minDate', new Date(newbieData.data('mindate')));
        dp.update('maxDate', new Date(newbieData.data('maxdate')));

        $.each(response.task, function (key, value) {
          const field = form.find('#' + key);
          field.val(value);

          if(key === 'plan_at' && value) {
            dp.selectDate(new Date(value));
          }

        });
      }
    });

    $('#editTaskModal').modal('show');
  });


  $('.js-create-employee-form-datepicker').datepicker({

    minDate: new Date('2019-01-01'),
    endDate: new Date('2022-01-01'),
    dateFormat: "dd M yyyy",
    onSelect: function onSelect(fd, date, inst) {
      let plan = inst.$el.next();
      if (date === '') {
        plan.val('');
      } else {
        let month = '' + (date.getMonth() + 1);
        let day = '' + date.getDate();
        let year = date.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        plan.val([year, month, day].join('-'));
      }
    }
  }).data('datepicker');


  $('.js-select-company').on('select2:select', function (e) {
    httpGet(`/dict/company/${e.params.data.id}/departments`, populateSelector('.js-select-department'));
  });
  $('.js-select-department').on('select2:select', function (e) {
    httpGet(`/dict/department/${e.params.data.id}/employees`, populateSelector('.js-select-mentor'));
  });

  $('.js-select-novice-from-company').on('select2:select', function (e) {
    httpGet(`/dict/company/${e.params.data.id}/departments`, populateSelector('.js-select-novice-from-department'));
  });
  $('.js-select-novice-from-department').on('select2:select', function (e) {
    httpGet(`/dict/department/${e.params.data.id}/employees`, populateSelector('.js-select-novice-subordinate'));
  });

  $('.js-select-hrs').select2({
    ajax: {
      delay: 250,
      dataType: 'json',
      url: '/dict/employee/search',
      processResults: function (data, params) {
        data.data.map((e) => {
          e.text = e.name;
        });
        return {
          results: data.data,
        };
      },
    },
    minimumInputLength: 3,
  });

  var mentors = [];

  $('.js-show-modal-notifications-settings').on('click', function (e){
    e.preventDefault();
    let form = $('#notification');
    form.modal('show');
  });


  $('.js-can-edit-mentor-tasks').on('change', function (e) {
    e.preventDefault();
    let pernumber = $('#mentor').val();
    let canEdit = $(this).prop('checked') ? 1 : 0;

    if(pernumber) {
      $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: "POST",
        url: '/mentor/allow',
        data: {pernumber: pernumber, can_edit: canEdit},
        success: function (response) {
          if(response.data && response.data.id) {
           let index = mentors.findIndex(x => x.id === response.data.id);
           if(index !== -1) {
             mentors[index] = response.data;
           }
          }
        },
        error: function (response) {
          console.log(response);
        }
      });
    }
  });

  //Assign mentor
  $('.js-add-mentor-modal').on('click', function (e) {
    e.preventDefault();
    let form = $('#addMentorModal');
    let newbie = $(this).data('newbie');
    let mentorPernumber = $(this).data('mentor');
    let mentorHiddenInput = form.find('#mentor');

    $.ajax({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      type: "GET",
      url: "/mentor/"+newbie,
      success: function (response) {
        if(response.data && response.data.length > 0) {

          mentors = [];
          $.each(response.data, function(key, mentor) {
            if (mentorPernumber === mentor.id) {
                mentorHiddenInput.val(mentor.id);

                var newOption = new Option(mentor.name, mentor.id, false, false);
                $('.js-select-fio').append(newOption).val(mentor.id).trigger('change')

                $('#can_edit').prop('checked', !!mentor.can);
                $('.can-edit-group').show();
            }
          });
        }
      },
      error: function (response) {
        console.log(response);
      }
    });

    form.modal('show');
  });


  //Mentor handlers
  $('.js-mentor-assign-action').submit(function (e) {
    e.preventDefault();
    let form = $('#addMentorModal');
    let mentorSelect = form.find('#mentor');

    if(!mentorSelect.val()) {
      const error = '<span class="adp-modal-field-invalid-text" role="alert">'+ 'Обязательно для заполнения' +'</span>';
      mentorSelect.after(error);
      return false;
    }
    return true;
  });


  makeFiltersSelected();

  $('.js-admin-grid-filter').on('change', function (e) {

    let getParams = '?';

    $('.js-admin-grid-filter').each(function (i, elem) {
      let value = encodeURIComponent($(elem).val());
      if (value != '' && value != '0') {
        let name = $(elem).attr('name');
        getParams += `${name}=${value}&`;
      }
    });

    getParams = getParams.substring(0, getParams.length - 1);

    if (getParams || window.location.search) {
      window.location.search = getParams;
    }
  });

  $('.js-edit-employee').on('click', function() {
    let pernumber = $(this).data('pernumber');

    let employee;
    httpGetPromise(`/dict/employee/${pernumber}`).then(
      (res) => {
        employee = res.data[0];
        return httpGetPromise(`/dict/company/${employee.companyId}/departments`)
      }
    ).then((res) => {
      populateSelector('.js-select-department')(res);
    }).then(() => {
      populateEditEmployeeForm(employee);
    });
  });

  $('#confirm-assign').on('show.bs.modal', function(e) {
    $(this).find('.js-btn-confirm').attr('href', $(e.relatedTarget).data('href'));
  });
  $('#confirm-assign-all').on('show.bs.modal', function(e) {
    $(this).find('.js-btn-confirm').attr('href', $(e.relatedTarget).data('href'));
  });
  $('#confirm-accept').on('show.bs.modal', function(e) {
    $(this).find('.js-btn-confirm').attr('href', $(e.relatedTarget).data('href'));
    $(this).find('form').attr('action', $(e.relatedTarget).data('href'));
  });
  $('#confirm-cancel').on('show.bs.modal', function(e) {
    $(this).find('form').attr('action', $(e.relatedTarget).data('href'));
  });
  $('#confirm-done').on('show.bs.modal', function(e) {
      console.log($(e.relatedTarget).data('href'));
      console.log(123);
    $(this).find('form').attr('action', $(e.relatedTarget).data('href'));
  });

    $('#add-mentor-form .js-select-pernumber').select2({
        ajax: {
            delay: 350,
            dataType: 'json',
            method: 'POST',
            url: $('#add-mentor-form').data('search-url'),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: function (params) {
                return {
                    pernumber: params.term,
                    fullname: '',
                    position: '',
                };
            },
            processResults: function (data, params) {
                data.data.map((e) => {
                    e.text = e.name;
                });
                return {
                    results: data.data,
                };
            },
        },
        minimumInputLength: 3,
    });

    $('#add-mentor-form .js-select-fio').select2({
        ajax: {
            delay: 350,
            dataType: 'json',
            method: 'POST',
            url: $('#add-mentor-form').data('search-url'),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: function (params) {
                return {
                    fullname: params.term,
                    position: '',
                    pernumber: '',
                };
            },
            processResults: function (data, params) {
                data.data.map((e) => {
                    e.text = e.name;
                });
                return {
                    results: data.data,
                };
            },
        },
        minimumInputLength: 3,
    });

    $('#add-mentor-form .js-select-position').select2({
        ajax: {
            delay: 350,
            dataType: 'json',
            method: 'POST',
            url: $('#add-mentor-form').data('search-url'),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: function (params) {
                return {
                    position: params.term,
                    fullname: '',
                    pernumber: '',
                };
            },
            processResults: function (data, params) {
                data.data.map((e) => {
                    e.text = e.name;
                });
                return {
                    results: data.data,
                };
            },
        },
        minimumInputLength: 3,
    });

    $('#add-mentor-form .js-select-pernumber,' +
        '#add-mentor-form .js-select-fio,' +
        '#add-mentor-form .js-select-position').on('select2:select', function (e) {
        let mentor = e.params.data;
        let canBox = $('#can_edit');

        $('#addMentorModal #mentor').val(mentor.id);
        // $('#addMentorModal .js-selected-mentor').val(mentor.name);

        if (!mentor) {
            return false;
        }

        canBox.prop('checked', !!mentor.can);

        $('.can-edit-group').show();

        if ($(this).hasClass('js-select-pernumber')) {
            $('#add-mentor-form .js-select-position').val(null).trigger('change');
            $('#add-mentor-form .js-select-fio').val(null).trigger('change');
        } else if ($(this).hasClass('js-select-fio')) {
            $('#add-mentor-form .js-select-position').val(null).trigger('change');
            $('#add-mentor-form .js-select-pernumber').val(null).trigger('change');
        } else if ($(this).hasClass('js-select-position')) {
            $('#add-mentor-form .js-select-position').val(null).trigger('change');
            $('#add-mentor-form .js-select-fio').val(null).trigger('change');
        }

    });

    $('.js-create-existes-tasks').on('click', evt => {
        let isActiveSubmit = false;
        $('.js-create-existes-tasks').each((i,elem) => {
            if ($(elem).is(':checked')) {
                isActiveSubmit = true;
            }
        });

        if ($(evt.target).is(':checked') === false) {
            $('.js-select-all-tasks').prop('checked', false);
        }

        $('.js-btn-create-existes-tasks').attr('disabled', !isActiveSubmit);
    });

    $('.js-select-all-tasks').on('click', evt => {
        $('.js-create-existes-tasks').each((i, elem) => {
            if ($(evt.target).is(':checked')) {
                $(elem).prop('checked', true);
                $('.js-btn-create-existes-tasks').attr('disabled', false);
            } else {
                $(elem).prop('checked', false);
                $('.js-btn-create-existes-tasks').attr('disabled', true);
            }
        });
    });

    $('.js-btn-create-existes-tasks').on('click', evt => {
        var submitButton = $(evt.target)
        submitButton.attr("disabled", true);
        let selectedTasksId = []
        $('.js-create-existes-tasks').each((i,elem) => {
            if ($(elem).is(':checked')) {
                selectedTasksId.push($(elem).data('task-id'));
            }
        });
        if (selectedTasksId.length > 0) {
            httpPostPromise(submitButton.data('href'), {'ids': selectedTasksId})
            .then((data) => {
                if (data.hasOwnProperty('success') && data.hasOwnProperty('redirect') && data.success) {
                    window.location = data.redirect;
                    submitButton.attr("disabled", false);
                }
            })
            .catch(() => {submitButton.html('error not found task!');});
        }
    });

    $('#create-provider-form').submit(function (e) {
        $('.adp-modal-field-invalid-text').remove();
        $('.adp-modal-field-label-invalid').removeClass('adp-modal-field-label-invalid');
        e.preventDefault();
        let form = $(this);
        $.ajax({
            type: "POST",
            url: $(this).attr('action'),
            data: $(this).serialize(),
            success: function () {
                location.reload();
            },
            error: function (request) {
                const json = $.parseJSON(request.responseText);

                $.each(json.errors, function (key, value) {
                    const field = form.find('#' + key);
                    const label = form.find("label[for='" + key + "']");
                    const error = '<span class="adp-modal-field-invalid-text" role="alert">' + value[0] + '</span>';
                    field.after(error);
                    label.addClass('adp-modal-field-label-invalid');
                });
            }
        });
    });

    $('#open-create-provider-form').on('click', function (e) {
        $('#adminModalUser #provider_id').val('')
        $('#adminModalUser #name_ru').val('')
        $('#adminModalUser #name_en').val('')
        $('#adminModalUser #name_fr').val('')

        $('#adminModalUser').modal('show');
    })

    $('.js-open-edit-provider-form').on('click', function (e) {
        let provider = $(this).data('provider')

        $('#adminModalUser #provider_id').val(provider.id)
        $('#adminModalUser #name_ru').val(provider.name_ru)
        $('#adminModalUser #name_en').val(provider.name_en)
        $('#adminModalUser #name_fr').val(provider.name_fr)

        $('#adminModalUser').modal('show');
    });

});


const httpGet = (url, callback, err = console.error) => {
  const request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.onload = () => callback(JSON.parse(request.responseText));
  request.onerror = () => err(request);
  request.send();
};

const httpGetPromise = (url) => {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      if (this.status == 200) {
        resolve(JSON.parse(this.response));
      } else {
        let error = new Error(this.statusText);
        error.code = this.status;
        reject(error);
      }
    };

    xhr.onerror = function () {
      reject(new Error("Network Error"));
    };

    xhr.send();
  });
};

const httpGetHtmlPromise = (url) => {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      if (this.status == 200) {
        resolve(this.response);
      } else {
        let error = new Error(this.statusText);
        error.code = this.status;
        reject(error);
      }
    };

    xhr.onerror = function () {
      reject(new Error("Network Error"));
    };

    xhr.send();
  });
};

window.httpGetHtmlPromise = httpGetHtmlPromise;


const httpPostPromise = (url, data) => {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));

    xhr.onload = function () {
      if (this.status == 200) {
        resolve(JSON.parse(this.response));
      } else {
        let error = new Error(this.statusText);
        error.code = this.status;
        reject(error);
      }
    };

    xhr.onerror = function () {
      reject(new Error("Network Error"));
    };

    xhr.send(JSON.stringify(data));
  });
};


const populateEditEmployeeForm = (employee) => {
  let form = $('#edit-employee-form');

  let formUrl = form.attr('action').split('/');
  formUrl.pop();
  formUrl.push(employee.id);
  form.attr('action', formUrl.join('/'));

  form.find('#pernumber').val(employee.id).attr('readonly', true);
  form.find('#name').val(employee.fullName);
  form.find('#phone').val(employee.phone);
  form.find('#email').val(employee.email);
  form.find('#company').val(employee.companyId).trigger('change');
  form.find('#department').val(employee.departmentId).trigger('change');
  form.find('#subdivision').val(employee.subdivisionId).trigger('change');
  form.find('#position_name').val(employee.position).trigger('change');

  if(employee.canEditCatalog) {
      form.find('#employeeIsEditCatalog').attr('checked', true);
  }

  let firedAt = form.find('#fired_at_datepicker').datepicker().data('datepicker');

  if(employee.firedAt && employee.firedAt !== '9000-01-01') {
      let timeTokens = employee.firedAt.split('-');
      firedAt.selectDate(new Date(timeTokens[0], timeTokens[1] - 1, timeTokens[2]));
  } else {
      form.find('#fired_at_datepicker').val('')
  }

  if(employee.addedBy !== 2) {
      form.find('#name').attr('readonly', true);
      form.find('#phone').attr('readonly', true);
      form.find('#email').attr('readonly', true);
      form.find('#company').attr('readonly', true).parent('div').css('pointer-events', 'none');
      form.find('#department').attr('readonly', true).parent('div').css('pointer-events', 'none');
      form.find('#subdivision').attr('readonly', true).parent('div').css('pointer-events', 'none');
      form.find('#position_name').attr('readonly', true).parent('div').css('pointer-events', 'none');
      form.find('#fired_at_datepicker').attr('readonly', true).parent('div').css('pointer-events', 'none');
  } else {
      form.find('#name').attr('readonly', false);
      form.find('#phone').attr('readonly', false);
      form.find('#email').attr('readonly', false);
      form.find('#company').attr('readonly', false).parent('div').css('pointer-events', '');
      form.find('#department').attr('readonly', false).parent('div').css('pointer-events', '');
      form.find('#subdivision').attr('readonly', false).parent('div').css('pointer-events', '');
      form.find('#position_name').attr('readonly', false).parent('div').css('pointer-events', '');
      form.find('#fired_at_datepicker').attr('readonly', false).parent('div').css('pointer-events', '');
  }

  $('#editModalUser').modal('show')
};


const populateSelector = (selector) => {
  let select = $(selector);
  return (opt) => {
    select.html('');
    select.select2({
      minimumResultsForSearch: Infinity,
    });
    select.append(new Option('', '', false, false));
    $.each(opt.data, function (key, value) {
      let newOption = new Option(value.name, value.id, false, false);
      select.append(newOption).trigger('change');
    });
    select.trigger('change');
  };
};

const makeFiltersSelected = () => {

  let searchStr = window.location.search.substring(1);
  let queryParams = searchStr ? JSON.parse('{"' + searchStr.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
    return key === "" ? value : decodeURIComponent(value)
  }) : {};

  $('.js-admin-grid-filter').each(function (i, elem) {
    let filter = $(elem);
    if (queryParams.hasOwnProperty(filter.attr('name'))) {
      filter.val(queryParams[filter.attr('name')]);
      filter.trigger('change');
    }
  });
};
